import React, {useState} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import zoomInIcon from '../../../assets/painterro-tool-icons/ZoomPlus.svg';
import zoomOutIcon from '../../../assets/painterro-tool-icons/ZoomMinus.svg';
import styles from './styles.module.scss';

const PageSheet = ({
                     pageNumber,
                     checkboxAllowed,
                     zoom,
                   }) => {
  const [checked, setChecked] = useState(false);
  const toggle = () => {
    setChecked(prevState => !prevState);
  };

  return <div className={styles.pageContainer} key={pageNumber}>
    {checkboxAllowed && (
      <label className={styles.checkboxContainer}>
        <input
          className={classnames(styles.input)}
          type='checkbox'
          checked={checked}
          onChange={toggle}
          name='pdf-page-checkbox'
          data-page-number={pageNumber}
        />
        <div className={classnames(styles.checkbox, {
          [styles.checked]: checked
        })}
        />
      </label>
    )}
    <Page
      pageNumber={pageNumber + 1}
      scale={zoom}
      className={styles.page}
    />
  </div>;
};

const PDFPreview = React.memo(({
                      url,
                      editMode = true,
                    }) => {
  const [totalPages, setTotalPages] = useState(1);
  const [zoom, setZoom] = useState(1);

  const countPages = pdf => setTotalPages(pdf.numPages);
  const zoomIn = () => setZoom(prevState => (prevState <= 5) ? prevState + 0.25 : prevState);
  const zoomOut = () => setZoom(prevState => (prevState >= 0.25) ? prevState - 0.25 : prevState);

  const handleLoadSuccess = pdf => {
    countPages(pdf);
  };

  const mapPages = () => {
    return new Array(totalPages)
      .fill('')
      .map((_, index) => {
        const checkboxAllowed = editMode && (totalPages > 1);
        return (
          <PageSheet
            pageNumber={index}
            checkboxAllowed={checkboxAllowed}
            zoom={zoom}
          />
        );
      });
  };

  return (
    <div className={styles.documentContainer}>
      <Document
        file={{url}}
        className={styles.document}
        onLoadSuccess={handleLoadSuccess}
      >
        {mapPages()}
      </Document>
      <div className={styles.toolbar}>
        <button type="button" onClick={zoomIn} className={styles.toolButton}>
          <img src={zoomInIcon} alt="zoom in"/>
        </button>
        <button type="button" onClick={zoomOut} className={styles.toolButton}>
          <img src={zoomOutIcon} alt="zoom out"/>
        </button>
      </div>
    </div>
  );
});

PDFPreview.propTypes = {
  url: PropTypes.string,
  editMode: PropTypes.bool,
  updateSelected: PropTypes.func,
};

export default PDFPreview;
